export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";